import React from 'react'
import {useIntl} from 'react-intl'
import styled from '@emotion/styled'
import {filterMessages} from 'components/Filters/filterMessages'
import {FacetType} from 'types/Search'
import {getFacetsSortedAlphabetically} from 'utils/facilities'

import {Box} from '@vio/atlas/helpers/Box'
import {cssTheme} from '@vio/atlas/themes'

import {FacetFilterProps} from '../FacetFilter'
import {FacetFilterList} from '../FacetFilterList/FacetFilterList'

const PopularWrapper = styled.div`
  margin-bottom: ${cssTheme.layout.spacing.s300};
`

interface FacetsRenderListProps extends FacetFilterProps {
  popularIsVisible: boolean
  popularFacets: FacetType[]
  validFacets: FacetType[]
}
export const FacetsRenderList: React.FC<FacetsRenderListProps> = ({
  popularIsVisible,
  popularFacets,
  validFacets,
  searchParamName,
  getLabel,
  onChange,
  columns,
  filters,
  limit,
  contractedMessage,
  showMoreRenderType,
  hasAppliedFilters
}) => {
  const {formatMessage} = useIntl()

  return (
    <Box width="100%">
      {popularIsVisible && (
        <PopularWrapper>
          <FacetFilterList
            title={formatMessage(filterMessages.popularTypes)}
            facets={popularFacets}
            filters={filters}
            searchParamName={searchParamName}
            getLabel={getLabel}
            onChange={onChange}
            columns={columns}
            showMoreRenderType={showMoreRenderType}
            hasAppliedFilters={hasAppliedFilters}
          />
        </PopularWrapper>
      )}
      <FacetFilterList
        title={popularIsVisible && formatMessage(filterMessages.allTypes)}
        facets={getFacetsSortedAlphabetically(
          validFacets,
          getLabel as (T: string) => string
        )}
        filters={filters}
        searchParamName={searchParamName}
        getLabel={getLabel}
        columns={columns}
        limit={limit}
        contractedMessage={contractedMessage}
        onChange={onChange}
        showMoreRenderType={showMoreRenderType}
        hasAppliedFilters={hasAppliedFilters}
      />
    </Box>
  )
}
